import { useEffect, useState } from 'react';
import { Entry } from 'contentful';
import InfiniteScroll from 'react-infinite-scroll-component';

import { client } from '../../helpers/contentful';
import { Spinner } from '../../components';
import { CourseCard } from '../../components/CourseCard';
import { ICourseFields } from '../../@types/generated/contentful';

const Academy = () => {
  const [courses, setCourses] = useState<Entry<ICourseFields>[]>([]);
  const [total, setTotal] = useState(0);

  const getCourses = async () => {
    const response = await client
      .getEntries<ICourseFields>({
        skip: courses.length,
        limit: 12,
        content_type: 'course',
      })
      .then((r) => r);

    if (total === 0) {
      setTotal(response.total);
    }

    setCourses((state) => [...state, ...response.items]);
    return response.items;
  };

  useEffect(() => {
    getCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='home'>
      {courses.length > 0 && (
        <>
          <div className='border-t-2 w-full'>
            <div className='mx-auto w-max p-6 md:p-3'>
              <InfiniteScroll
                dataLength={courses.length}
                next={getCourses}
                // eslint-disable-next-line react/jsx-boolean-value
                hasMore={courses.length < total}
                scrollableTarget='app'
                style={{ overflow: 'visible' }}
                loader={
                  <div className='mt-4 flex justify-center'>
                    <Spinner theme='light' />
                  </div>
                }
              >
                <ul className='grid sm:grid-cols-1 gap-5 grid-cols-2 w-max md:gap-3'>
                  {courses.map(({ fields, sys }) => (
                    <li key={sys.id}>
                      <CourseCard course={fields} />
                    </li>
                  ))}
                </ul>
              </InfiniteScroll>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export { Academy };
